import { PageHeader } from "@/components/PageHeader";
import { UserImport } from "@/components/admin/UserImport";
import { useAuth } from "@/context/AuthContext";
import { useCompany } from "@/context/CompanyContext";

export default function UsersImportPage() {
  const { user } = useAuth();
  const { company } = useCompany();
  return (
    <div className="space-y-6" data-testid="users-import-page">
      <PageHeader eyebrow="Company" title="Import users" subtitle={`Add or update task users of ${company?.name || "your company"} from Excel.`} />
      <UserImport cid={user.company_id} slug={company?.slug} />
    </div>
  );
}
